#import "../fragments/account-basic.graphql"

query GetAccountsSearchResults($query: String, $limit: Int) {
    search(query: $query, type: ACCOUNT, limit: $limit) {
        quickResults {
            recentResults {
                ... on Lead {
                    id
                    name
                }
                ... on Account {
                    ...AccountBasic
                }
                ... on Contact {
                    id
                    name
                }
            }
            accountResults {
                ...AccountBasic
            }
        }
    }
}
